module.exports = __webpack_public_path__ + "img/deep_sleeper.34b6f246.svg";